import { FormattedMessage } from 'react-intl';

import { TextareaInput } from '@/modules/forms';
import { CopyButton } from '@/modules/ui';
import { hasReadPermission } from '@/utilities/permission';

import { Fields, type SecretType } from '../../../constants';
import type { Secret } from '../../../types';
import { SecretFieldSection } from '../../SecretFieldSection';
import { EmptyContentGuard } from '../EmptyContentGuard';

export interface SecureNoteSectionsProps {
    secret: Extract<Secret, { type: SecretType.SecureNote }>;
}

export const SecureNoteSections = ({ secret }: SecureNoteSectionsProps) => {
    const { userPermissions, secureNote, sensitiveFields } = secret;

    const hasRead = hasReadPermission(userPermissions);

    return (
        <EmptyContentGuard>
            {sensitiveFields?.includes(Fields.SECURE_NOTE) && (
                <SecretFieldSection heading={<FormattedMessage id='secret.secureNote.label' />}>
                    <CopyButton type='secureTextArea' disabled={!hasRead} text={secureNote!}>
                        <TextareaInput readOnly rows={5} value={secureNote!} />
                    </CopyButton>
                </SecretFieldSection>
            )}
        </EmptyContentGuard>
    );
};
